export default __webpack_public_path__ + "static/media/alphabet-yellow-y.66d2c458.png";